import { useAccessTokenGetter } from '@flintmint/web-shared/hooks/use-auth-user';

import { checkPromptSlug } from '@/services/prompts-service';

export interface PromptSlugErrors {
  moduleSelectionPromptSlug?: string;
  corePromptSlug?: string;
}

export const MISSING_PROMPT_SLUG_ERROR = 'No Braintrust prompt with this slug in this environment';

/**
 * Returns a save-time check that flags each slug Braintrust reports as missing. A slug whose check
 * couldn't complete is not flagged, so an unreachable Braintrust never blocks a save.
 */
export const usePromptSlugValidation = () => {
  const getAccessToken = useAccessTokenGetter();

  return async (slugs: Record<keyof PromptSlugErrors, string>): Promise<PromptSlugErrors> => {
    const accessToken = await getAccessToken();
    const fields = Object.keys(slugs) as (keyof PromptSlugErrors)[];
    const statuses = await Promise.all(fields.map((field) => checkPromptSlug(slugs[field], accessToken)));

    return Object.fromEntries(
      fields.flatMap((field, index) => (statuses[index] === 'missing' ? [[field, MISSING_PROMPT_SLUG_ERROR]] : []))
    );
  };
};
